import imageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import type { Image } from "sanity";

export const client = createClient({
  projectId: "6td8xer3",
  dataset: "production",
  apiVersion: "2024-01-01",
  useCdn: true,
  stega: {
    studioUrl: process.env.VERCEL_URL
      ? `https://${process.env.VERCEL_URL}/studio`
      : `${process.env.NEXT_PUBLIC_BASE_URL}/studio`,
  },
});

// image builder
const builder = imageUrlBuilder(client);

// Typový návrh pro Sanity obrázek
type SanityImageSource = Image | { asset: { _ref: string; _type: string } };

export function urlFor(source: SanityImageSource) {
  return builder.image(source);
}
